/**
 * Tours específicos para el layout de la aplicación
 */
export const getLayoutTour = (theme) => {
  return {
    header: [
      {
        element: `.GM__${theme}-header-container-greeting`,
        popover: {
          title: 'Saludo y Navegación',
          description: 'Aquí aparece tu saludo personalizado cuando estás en el dashboard, o el título de la ruta cuando navegas a otras secciones.',
          position: 'bottom'
        }
      },
      {
        element: `.GM__${theme}-search-wrapper`,
        popover: {
          title: 'Búsqueda Global',
          description: 'Utiliza esta barra para buscar por placa, operador (CC), o cualquier dato relevante en toda la aplicación.',
          position: 'bottom'
        }
      },
      {
        element: `.GM__${theme}-chip-pointer`,
        popover: {
          title: 'Selector de Fecha',
          description: 'Cambia la fecha para consultar datos históricos. En el dashboard verás información de ese día específico.',
          position: 'bottom-left'
        }
      },
      {
        element: `.GM__${theme}-icon-button`,
        popover: {
          title: 'Centro de Ayuda',
          description: 'Accede a todos los tours disponibles y opciones de ayuda desde aquí.',
          position: 'bottom-left'
        }
      }
    ],

    leftNav: [
      {
        element: '.sidebar-header',
        popover: {
          title: 'Logo y Marca',
          description: 'Identidad visual de la aplicación. Haz clic aquí para volver al dashboard principal.',
          position: 'right'
        }
      },
      {
        element: '.sidebar-body-routes',
        popover: {
          title: 'Menú Principal',
          description: 'Navega entre las diferentes secciones de la aplicación. Cada sección tiene funcionalidades específicas.',
          position: 'right'
        }
      },
      {
        element: '.sidebar-folder',
        popover: {
          title: 'Carpetas de Organización',
          description: 'Las secciones relacionadas se agrupan en carpetas desplegables para mejor organización.',
          position: 'right'
        }
      },
      {
        element: '.sidebar-footer-upload',
        popover: {
          title: 'Centro de Cargas',
          description: 'Monitorea el progreso de tus archivos cargados y gestiona las tareas de importación.',
          position: 'right'
        }
      },
      {
        element: '.sidebar-hide-panel',
        popover: {
          title: 'Contraer/Expandir',
          description: 'Optimiza tu espacio de trabajo ocultando o mostrando el panel lateral según tus necesidades.',
          position: 'right'
        }
      },
      {
        element: '.theme-switch',
        popover: {
          title: 'Cambio de Tema',
          description: 'Personaliza tu experiencia visual alternando entre tema claro y oscuro.',
          position: 'right'
        }
      }
    ],

    general: [
      {
        element: '.GM__page-content',
        popover: {
          title: 'Área de Contenido',
          description: 'Esta es la zona principal donde se muestra la información y funcionalidades de cada sección.',
          position: 'center'
        }
      }
    ]
  };
};